/**
 * 清理所有飞行中的筹码（用于重置或异常情况）
 */
export function cleanupFlyingChips(): void {
  const flyingChips = document.querySelectorAll('.flying-chip-temp');
  flyingChips.forEach(chip => chip.remove());
  
  // console.log('[🧹 清理] 已清理所有飞行筹码:', flyingChips.length);
}
